import { useEffect, useState } from "preact/hooks";
import { api } from "../api";
import type { DaySummary, Meal } from "@hh/shared";

const MEAL_ORDER: Meal[] = ["breakfast", "lunch", "dinner", "snack"];
const MEAL_LABEL: Record<Meal, string> = {
  breakfast: "Breakfast", lunch: "Lunch", dinner: "Dinner", snack: "Snacks",
};

function shiftDate(date: string, days: number): string {
  const d = new Date(date + "T00:00:00");
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
}

export function Diary({ reloadKey }: { reloadKey: number }) {
  const [date, setDate] = useState(() => new Date().toISOString().slice(0, 10));
  const [day, setDay] = useState<DaySummary | null>(null);

  function load(d: string) {
    api.day(d).then(setDay).catch(() => setDay(null));
  }
  useEffect(() => { load(date); }, [date, reloadKey]);

  async function del(id: number) {
    await api.deleteFood(id);
    load(date);
  }

  const isToday = date === new Date().toISOString().slice(0, 10);
  const tot = day?.totals ?? { kcal: 0, protein_g: 0, carbs_g: 0, fat_g: 0 };
  const empty = day && !MEAL_ORDER.some((m) => day.byMeal[m].length);

  return (
    <div class="app-shell fade-in">
      <div class="screen-head">
        <div><div class="eyebrow">History</div><h1>Diary</h1></div>
      </div>

      <div class="card" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <button class="btn ghost" style={{ width: "auto" }} onClick={() => setDate(shiftDate(date, -1))}>‹</button>
        <div style={{ textAlign: "center" }}>
          <div style={{ fontWeight: 650 }}>
            {new Date(date + "T00:00:00").toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" })}
          </div>
          <div class="muted">{tot.kcal} kcal · {tot.protein_g}g protein</div>
        </div>
        <button class="btn ghost" style={{ width: "auto" }} disabled={isToday} onClick={() => setDate(shiftDate(date, 1))}>›</button>
      </div>

      {empty ? (
        <div class="card"><div class="empty"><div class="ico">📖</div><p>Nothing logged this day.</p></div></div>
      ) : (
        MEAL_ORDER.map((meal) => {
          const items = day?.byMeal[meal] ?? [];
          if (!items.length) return null;
          const mk = items.reduce((s, it) => s + it.kcal, 0);
          return (
            <div class="card meal-group" key={meal}>
              <h3>{MEAL_LABEL[meal]}<span>{Math.round(mk)} kcal</span></h3>
              {items.map((it) => (
                <div class="diary-item" key={it.id}>
                  <div>
                    <div style={{ fontWeight: 600 }}>{it.name}</div>
                    <div class="qty">
                      {it.amount}{it.unit === "serving" ? " serving" : it.unit} · {Math.round(it.protein_g)}P {Math.round(it.carbs_g)}C {Math.round(it.fat_g)}F
                    </div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span class="kc">{Math.round(it.kcal)}</span>
                    <button class="del" onClick={() => del(it.id)} aria-label="Delete">×</button>
                  </div>
                </div>
              ))}
            </div>
          );
        })
      )}
    </div>
  );
}
